document.addEventListener("DOMContentLoaded", function() {
  //const html5QrCode = new Html5Qrcode("reader");
  const readerActions = document.getElementById('reader-actions');
  const readerCode = document.getElementById('reader-code');
  const retryButton = document.getElementById('retry');
  const readerMessage = document.getElementById('reader-message');
  const loadingImage = document.getElementById('reader-loading');
  const addBarcodeContainer = document.getElementById('add-barcode-container');
  const enteredBarcodeNumber = document.getElementById('entered-barcode-number');
  const continueButton = document.getElementById('continue-button');
  const enteredBarcodeError = document.getElementById('entered-barcode-error');
  const codeReader = new ZXing.BrowserMultiFormatReader();
  const videoContainer = document.getElementById('reader');
  const loadingMessage = document.getElementById('loading-message');
  const loadingMessageTexts = [
    "Estamos creando la ficha del producto...",
    "Esto puede tardar unos segundos...",
    "Casi listo, gracias por tu paciencia..."
  ];
  let messageIndex = 0;
  let intervalId = null;

  if(continueButton) {
    continueButton.addEventListener('click',function(e){
      e.preventDefault();      
      if(enteredBarcodeNumber.value.length < 8 || enteredBarcodeNumber.value.length > 13) {
        enteredBarcodeError.innerHTML = "El valor del código de barras debe ser de 8 a 13 números.";
      } else {
        enteredBarcodeError.innerHTML = "";
        let enteredCode = enteredBarcodeNumber.value;
        if(enteredCode.length > 8) {  
          enteredCode = enteredCode.padStart(13, "0");
        }
        console.log("Normalizado:", enteredCode);

        if(readerActions){
          readerCode.innerHTML = enteredCode;
          readerActions.style.display = 'block';
        }          
        codeReader.reset();
        videoContainer.style.display = 'none';
        processBarcode(enteredBarcodeNumber.value);     
      }
      return false;
    });
  }

  /*const qrCodeSuccessCallback = (decodedText, decodedResult) => {
      // Normalizar código
      if(decodedText.length > 8) {  
        decodedText = decodedText.padStart(13, "0");
      }

      if(readerActions){
        readerCode.innerHTML = decodedText;
        readerActions.style.display = 'block';
      }

      processBarcode(decodedText);

      html5QrCode.stop().catch((err) => {
        console.error("Unable to stop scanning.", err);
      });
  };

  const qrConfig = { fps: 15, qrbox: { width: 350, height: 263 } };
  html5QrCode.start({ facingMode: "environment" }, qrConfig, qrCodeSuccessCallback);*/

  //const codeReader = new ZXing.BrowserMultiFormatReader();
  let hits = {};
  let totalScans = 0;

  // Stabilizer settings
  const MAX_SCANS = 12;     // number of frames to analyze
  const CONFIDENCE = 0.6;   // 60% agreement required

  codeReader.decodeFromVideoDevice(null, "reader", (result, err) => {
    if (result) {
      let code = result.getText();
      processScan(code);
    }
    /*if (result) {
      let decodedText = result.getText();
      console.log("Scanned:", decodedText);
      // Normalizar código
      if(decodedText.length > 8) {  
        decodedText = decodedText.padStart(13, "0");
      }
      console.log("Normalizado:", decodedText);

      if(readerActions){
        readerCode.innerHTML = decodedText;
        readerActions.style.display = 'block';
      }

      processBarcode(decodedText);

      codeReader.reset(); // stop scanning after first detection
    }*/
  });


  // ---------- STABILIZER LOGIC ----------
  function processScan(code) {
    if (!code) return;

    // Count hits
    hits[code] = (hits[code] || 0) + 1;
    totalScans++;

    // After X scans → choose best one
    if (totalScans >= MAX_SCANS) {
      let stable = getStableResult();

      if (stable) {
        console.log("Stable result:", stable);
        if(stable.length > 8) {  
          stable = stable.padStart(13, "0");
        }
        console.log("Normalizado:", stable);

        if(readerActions){
          readerCode.innerHTML = stable;
          readerActions.style.display = 'block';
        }

        processBarcode(stable);
        codeReader.reset(); // stop scanning after stable result
      } else {
        // If no consensus, reset and keep scanning
        console.log("No stable result, continuing scans...");
        resetStabilizer();
      }
    }
  }

  function getStableResult() {
    const entries = Object.entries(hits);
    console.log("Scan results:", entries, "Total scans:", totalScans);
    if (entries.length === 0) return null;

    // Sort by hits descending
    entries.sort((a, b) => b[1] - a[1]);

    const [bestCode, bestHits] = entries[0];

    // Check if majority threshold met
    if (bestHits / totalScans >= CONFIDENCE) {
      return bestCode;
    }

    return null;
  }

  function resetStabilizer() {
    hits = {};
    totalScans = 0;
  }



  if(retryButton) {
    retryButton.addEventListener('click',function(e){
      e.preventDefault();
      window.location.reload(true);      
    });
  }

  /*****************************
   * 1) Lógica principal
   *****************************/
  async function processBarcode(barcode) {
    console.log("Procesando barcode:", barcode);

    // 1) Intentar encontrar producto en Shopify
    const shopifyProductUrl = await findProductInShopify(barcode);

    if (shopifyProductUrl) {
      console.log("→ Producto encontrado en Shopify:", shopifyProductUrl);
      window.location.href = shopifyProductUrl;
      return;
    }

    console.log("→ Producto NO existe en Shopify. Consultando middleware…");

    // 2) Intentar crearlo vía middleware
    const mwResult = await fetchCreateProductMw(barcode);

    if (!mwResult || mwResult.ok === false || mwResult.exists === false) {
      // Barcode no existe en la base
      console.log("→ No existe en la base de datos intermedia.");
      showNotFoundMessage();
      return;
    }

    // Resultado puede ser:
    // { ok: true, created: true, product_id }
    // { ok: true, exists: true, product_id }

    const productId = mwResult.product_id;
    const handle = mwResult.handle;
    console.log('Product mwResult', mwResult);
    console.log('Product handle', handle);

    if (!productId) {
      console.error("Middleware no devolvió product_id válido:", mwResult);
      showNotFoundMessage();
      return;
    }

    console.log("→ Producto creado o validado en Shopify. ID:", productId);

    // 3) Redireccionar al producto recién creado
    if(handle) {
      window.location.href = `/products/${handle}`;
    } else {
      console.log("Handle es undefined");
      if(readerActions){
        console.log("Mostrar error");
        readerCode.innerHTML = barcode;
        readerActions.style.display = 'block';
        loadingImage.style.display = 'none';
        readerMessage.style.display = 'block';
        retryButton.style.display = 'block';
      } 
    }
  }

  /*****************************
   * 2) Buscar producto en Shopify
   *****************************/
  async function findProductInShopify(barcode) {
    try {
      const response = await fetch(
        `/search/suggest.json?q=${barcode}&resources[type]=product&resources[options][fields]=variants.barcode`
      );
      const data = await response.json();
      console.log('Product data', data.resources.results);

      if (data.resources.results.products.length === 0) {
        return null;
      }

      return data.resources.results.products[0].url;

    } catch (error) {
      console.error('Error buscando en Shopify:', error);
      return null;
    }
  }

  /*****************************
   * 3) Llamar al middleware
   *****************************/
  async function fetchCreateProductMw(barcode) {
    startMessageRotation();
    try {
      const response = await fetch(`https://middleware.bebelandia.ec/api/giftLis/use-barcode?barcode=${barcode}`);      
      const data = await response.json();
      stopMessageRotation();
      console.log("Respuesta middleware:", data);
      return data;
    } catch (error) {
      stopMessageRotation();
      console.error('Error llamando al middleware:', error);
      return null;
    }
  }

  /*****************************
   * 4) Mostrar mensaje de error
   *****************************/
  function showNotFoundMessage() {
    readerMessage.style.display = 'block';
    retryButton.style.display = 'block';
    loadingImage.style.display = 'none';
  }

  //Funciones de mensajes al crear nuevas fichas
  function startMessageRotation() {
      if (intervalId) return; // evita múltiples intervalos

      // Mostrar inmediatamente el primer mensaje
      loadingMessage.textContent = loadingMessageTexts[0];
      messageIndex = 1;

      intervalId = setInterval(() => {
        loadingMessage.textContent = loadingMessageTexts[messageIndex];
        messageIndex = (messageIndex + 1) % loadingMessageTexts.length;
      }, 2000);
    }
  function stopMessageRotation() {
    loadingMessage.textContent = '';
    clearInterval(intervalId);
    intervalId = null;
  }

});
